module.exports = __webpack_public_path__ + "static/media/48383570_2308751795866665_4291451504490971136_o-thumb.3b727d0d.jpg";